import React from "react";
import UserGuide from "../helpers/userGuide";
import "./About.scss";

const About: React.FC = () => {
  return (
    <div className="about">
      <div className="about-container">
        <h1>About InstaMusicTools</h1>
        <div className="about-content">
          <p>
            If you want to put a virtual piano onto your video, this tool will help you do that.
            Use midi and you can download your video with all the notes that were played.
            It simplifies adding a piano to your video and makes it faster to share. 
            You might need to convert the video to mp4 on a different website if your video is large.
            You need to enable midi in your browser and connect a midi cable.
          </p>
          
          <h2>Our Tools</h2>
          <div className="tools-list">
            <div className="tool-item">
              <h3>Piano Video Tool</h3>
              <p>
                A powerful piano visualization tool that helps you create engaging 
                piano content for social media and educational purposes..
              </p>
            </div>
          </div>

          <h2>Features</h2>
          <ul className="features-list">
            <li>Real-time piano visualization</li>
            <li>MIDI input support</li>
            <li>Customizable piano appearance</li>
            <li>Video recording capabilities</li>
            <li>Responsive design for all devices</li>
          </ul>

          <h2>User Guide</h2>
          <div className="user-guide-section">
            <UserGuide />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
